/**
 * TextInput Atom Component
 * Controlled input field with dark theme styling
 */

import React from 'react';
import type { TextInputProps } from '@/types';

export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  placeholder = '',
  type = 'text',
  className = '',
  disabled = false,
}) => {
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={`
        w-full px-5 py-2.5 border-2 border-black
        bg-transparent text-black placeholder-black/50
        font-space-mono font-bold text-sm
        rounded-none focus:outline-none transition-colors
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
    />
  );
};

export default TextInput;
